import React, { useMemo } from 'react'
import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import { Button } from '../../utils/Button'

const RequestFormStepButtons = ({ currentStep }) => {
  const isAuthenticated = useSelector(store => store.session.isAuthenticated)
  const requestForm = useFormikContext()

  const lastStep = useMemo(() => (isAuthenticated || requestForm.values.uuid ? 3 : 4), [isAuthenticated, requestForm])
  const finalSubmit = useMemo(() => currentStep === lastStep, [currentStep, lastStep])

  return (
    <div className="mt-2">
      <Button type="submit" className="w-full" color="darkGreen" onClick={() => {}} disabled={requestForm.isSubmitting}>
        {finalSubmit ? (
          <>Submit Request</>
        ) : (
          <>
            Next Step
            <FontAwesomeIcon icon={faChevronRight} className="ml-4" />
          </>
        )}
      </Button>
    </div>
  )
}

export default RequestFormStepButtons
